module.exports = __webpack_public_path__ + "img/c9fa2dc.jpg";